import { render, staticRenderFns } from "./BaseSelectGroup.vue?vue&type=template&id=35b8381d&"
import script from "./BaseSelectGroup.vue?vue&type=script&lang=js&"
export * from "./BaseSelectGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports